/**
 * Yanyu's terrain for the 3D world (heights.ts), over its authored layout (data/layouts/yanyu.ts,
 * docs/archive/YANYU.md §6). The layout's level layer already holds every height the rules stand on: the
 * bay at 0, the quay at 1.5, the village road climbing ten stone steps to the shrine's courtyard
 * (4) and on to the plaza (6), the temple base 6 m up, the pagoda rock at 13, the terraces of the
 * elder (8) and the six schools (8.5), the training ground (7) and its falls, the rice terraces
 * stepping down to the village gate (3), the arena's cape (4.5), the hills outside.
 *
 * What is left here is only to look at: the sea's shelf, how deep the ponds and brooks are, which
 * banks are sand, stone or reeds, and the names of the bridges and piers.
 */
import type { LevelHeightSpec } from '../../heights';

export const YANYU_HEIGHTS: LevelHeightSpec = {
  zone: 'yanyu',
  sea: {
    shelf: -0.3,
    drop: 0.45,
    deepest: -6,
    stoneShelf: -1.2,
    shores: [
      // The rocks where the waves break, round the wave cape.
      { rect: [26, 44, 8, 30], shore: 'stone' },
      // Reed beds in the quiet cove where the lower brook meets the sea.
      { rect: [12, 26, 24, 46], shore: 'reeds' },
    ],
  },
  ponds: [
    {
      name: 'lotus lagoon',
      at: [108.5, 40.5],
      kind: 'pond',
      depth: 1.2,
      shore: 'sand',
      shores: [{ rect: [94, 101, 30, 52], shore: 'reeds' }],
    },
    { name: 'falls pool', at: [23.5, 68], kind: 'pool', depth: 1.6, shore: 'stone' },
  ],
  brooks: [
    { name: 'lower brook', at: [25.5, 40], depth: 0.5, shore: 'stone' },
    { name: 'upper brook', at: [10, 78], depth: 0.4, shore: 'stone' },
    { name: 'east stream', at: [130, 54], depth: 0.5, shore: 'reeds' },
  ],
  bridges: [
    { name: 'pass bridge', at: [25.5, 57] },
    { name: 'arched bridge', at: [105.5, 30.5] },
    { name: 'zigzag bridge', at: [100.5, 42.5] },
  ],
  piers: [
    { name: 'pier and landing stage', at: [80.5, 20] },
    { name: 'fishing jetty', at: [92.5, 25] },
  ],
  paddy: { under: 0.05, bed: 0.12 },
  bank: 1.2,
};
